import { render, staticRenderFns } from "./ButtonAddDocuments.vue?vue&type=template&id=52526907&scoped=true"
import script from "./ButtonAddDocuments.vue?vue&type=script&lang=js"
export * from "./ButtonAddDocuments.vue?vue&type=script&lang=js"
import style0 from "./ButtonAddDocuments.vue?vue&type=style&index=0&id=52526907&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52526907",
  null
  
)

export default component.exports